import { objectInvalid } from "../../../helper";

export function validateDimensions({ dimensions }) {
  if (objectInvalid(dimensions)) return null;

  const match = Object.values(dimensions).find((i) => i?.type === "error");
  return match;
}
